import '../styles.scss'

import React, { useRef } from 'react'
import { useActions, useValues } from 'kea'
import Autosuggest from 'react-autosuggest'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import HighlightText from 'lib/utils/highlight-text'
import { indexSlugPath } from 'lib/utils/links'

import logic from '../logic'

const Category = ({ clearOnFocus }) => {
  const skipNextClear = useRef(null)
  const { fetchValue, suggestions, category, sections, isFetchingSuggestions } = useValues(logic)
  const { getSuggestions, setSuggestions, setCategory, setFetchingSuggestionsStatus } = useActions(logic)

  const alwaysTrue = () => true

  const onSuggestionsFetchRequested = ({ value }) => {
    getSuggestions(value)
  }

  const onSuggestionsClearRequested = () => {
    if (skipNextClear) {
      return
    }
    setSuggestions({ suggestions: [], value: '' })
  }

  const onSuggestionSelected = (event, { suggestion }) => {
    const url = window.location.origin + indexSlugPath(suggestion.slug)
    if (suggestion.extra) {
      try {
        const newWindow = window.open(url, '_blank')
        newWindow.focus()
      } catch {
        window.location.href = window.location.origin + indexSlugPath(suggestion.slug)
      }
    }

    setFetchingSuggestionsStatus(true)
  }

  const getSuggestionValue = suggestion => (suggestion.withText ? suggestion.text : suggestion.name)

  const renderSuggestion = (suggestion, { isHighlighted }) => {
    if (!isFetchingSuggestions || !category) {
      return (
        <div className={`item${isHighlighted ? ' focused' : ''}${suggestion.extra ? ' extra' : ''}`}>
          <HighlightText highlight={fetchValue}>{suggestion.name}</HighlightText>
        </div>
      )
    }
  }

  const onBlur = () => {
    if (!clearOnFocus) {
      skipNextClear.current = true
    }

    setFetchingSuggestionsStatus(true)
  }

  const onChange = (event, { newValue }) => {
    setCategory(newValue)
  }

  const onClick = event => event.target.select()

  const inputProps = {
    id: 'filter-search',
    name: 'activity-select',
    value: category,
    placeholder: I18n.t('react.request.category.activity_select_placeholder'),
    onChange,
    onBlur,
    onClick,
    'aria-label': I18n.t('react.request.category.activity_select_placeholder')
  }

  const renderSectionTitle = () => !category && <div>{I18n.t('react.request.category.search_popular')}</div>

  const getSectionSuggestions = section => {
    return section ? section.suggestions : []
  }

  return (
    <div
      className={`activity-select ${
        category ? !isFetchingSuggestions && 'suggestions-container' : 'empty-suggestions-container'
      }`}
    >
      <Autosuggest
        shouldRenderSuggestions={alwaysTrue}
        focusInputOnSuggestionClick={false}
        suggestions={fetchValue ? suggestions : sections}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        onSuggestionSelected={onSuggestionSelected}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
        multiSection={!fetchValue}
        renderSectionTitle={renderSectionTitle}
        getSectionSuggestions={getSectionSuggestions}
      />
    </div>
  )
}

Category.propTypes = {
  clearOnFocus: PropTypes.bool
}

export default Category
